import { Divider, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getVariants } from "utils/LaravelApi/LaravelAPI";
import { Link } from "react-router-dom";

export default function SpecificationOilSelector() {

    const { oilType, brand } = useParams();
    const [variants, setVariants] = useState([]);

    useEffect(() => {

        const fetchVariants = async () => {
            const variants = await getVariants(oilType, brand);
            if (variants.success) {
                setVariants(variants.data);
            }
        };
        fetchVariants();
    }, [brand, oilType]);

    return (
        <Grid container spacing={3} style={{ marginBottom: "30px" }}>
            {variants.map((model, idx) => {
                return (
                    <>
                        <Model idx={idx} model={model} />
                        <Variantes model={model} brand={brand} type={oilType} />
                    </>
                );
            })}
        </Grid>
    );
}

function Model({ idx, model }) {
    return (
        <Grid key={`model-${idx}`} item sm={12}>
            <Divider
                style={{
                    marginTop: "30px",
                    backgroundColor: "black",
                    height: "1px",
                    marginLeft: "5%",
                    marginRight: "5%",
                    marginBottom: "10px",
                }}
            />
            <div
                style={{
                    textAlign: "left",
                    marginLeft: "5%",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: "500",
                    fontSize: "25px",
                }}
            >
                {" "}
                {model.caracteristica}{" "}
            </div>
            <Divider
                style={{
                    marginTop: "10px",
                    backgroundColor: "black",
                    height: "1px",
                    marginLeft: "5%",
                    marginRight: "5%",
                }}
            />
        </Grid>
    );
}

function Variantes({ model, brand, type }) {

    const colCount = 2;
    const chunkedVariants = [];
    const variants = [...model.unidades].sort((a, b) =>
        a.name.localeCompare(b.name)
    );

    for (let i = 0; i < variants.length; i += colCount) {
        chunkedVariants.push(variants.slice(i, i + colCount));
    }

    return (
        <>
            {chunkedVariants.map((columnVariants, colIndex) => (
                <Grid container key={colIndex} item sm={4}>
                    {columnVariants.map((variant, idx) => (
                        <Grid
                            key={`variant-${idx}`}
                            item
                            sm={12}
                            style={{ color: "#bc0900", padding: '20px' }}
                        >
                            <Link
                                to={`/OilProduct/${type}/${brand}/${model.caracteristica}/${variant}`}
                                style={{
                                    textDecoration: 'none',
                                    fontSize: "22px",
                                    fontWeight: "900",
                                    color: "#0000EE",
                                    cursor: "pointer",
                                }}
                            >
                                {brand} {model.caracteristica} ({variant})
                            </Link>
                        </Grid>
                    ))}
                </Grid>
            ))}
        </>
    );
}
